
import mapboxgl from 'mapbox-gl';

export interface LoginLocation {
  id: string;
  employee_name: string;
  location_lat: number;
  location_lng: number;
  location_address?: string;
  login_time: string;
  logout_time?: string;
  ip_address?: string;
}

export const createMarkerElement = (): HTMLDivElement => {
  const el = document.createElement('div');
  el.className = 'custom-marker';
  el.innerHTML = `
    <div class="w-8 h-8 bg-blue-600 rounded-full border-2 border-white shadow-lg flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
      <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
      </svg>
    </div>
  `;
  return el;
};

export const createMarkerPopup = (location: LoginLocation): mapboxgl.Popup => {
  return new mapboxgl.Popup({
    offset: 25,
    closeButton: true,
    closeOnClick: false
  }).setHTML(`
    <div class="p-3 min-w-[200px]" dir="rtl">
      <h3 class="font-bold text-lg mb-2">${location.employee_name}</h3>
      <div class="space-y-1 text-sm">
        <p><strong>وقت الدخول:</strong> ${new Date(location.login_time).toLocaleString('ar-SA')}</p>
        ${location.logout_time ? 
          `<p><strong>وقت الخروج:</strong> ${new Date(location.logout_time).toLocaleString('ar-SA')}</p>` : 
          '<p class="text-green-600"><strong>الحالة:</strong> نشط</p>'
        }
        ${location.location_address ? `<p><strong>العنوان:</strong> ${location.location_address}</p>` : ''}
        ${location.ip_address ? `<p><strong>IP:</strong> ${location.ip_address}</p>` : ''}
      </div>
    </div>
  `);
};

export const addMarkersToMap = (
  map: mapboxgl.Map, 
  locations: LoginLocation[], 
  existingMarkers: mapboxgl.Marker[]
): mapboxgl.Marker[] => {
  // إزالة الدبابيس الموجودة
  existingMarkers.forEach(marker => marker.remove());
  
  const newMarkers: mapboxgl.Marker[] = [];
  
  locations.forEach(location => {
    const el = createMarkerElement();
    const popup = createMarkerPopup(location);

    const marker = new mapboxgl.Marker(el)
      .setLngLat([location.location_lng, location.location_lat])
      .setPopup(popup)
      .addTo(map);

    newMarkers.push(marker);
  });

  // تركيز الخريطة على المواقع
  if (locations.length > 0) {
    const bounds = new mapboxgl.LngLatBounds();
    locations.forEach(location => {
      bounds.extend([location.location_lng, location.location_lat]);
    });
    
    if (!bounds.isEmpty()) {
      map.fitBounds(bounds, {
        padding: 50,
        maxZoom: 12
      });
    }
  }

  return newMarkers;
};
